var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V6.64062H6.64062V0H0ZM5.07812 5.07812H1.5625V1.5625H5.07812V5.07812Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 2.53906H2.53906V4.10156H4.10156V2.53906Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 0V6.64062H20V0H13.3594ZM18.4375 5.07812H14.9219V1.5625H18.4375V5.07812Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4609 2.53906H15.8984V4.10156H17.4609V2.53906Z",
    fill: "#1F1F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3594V20H6.64062V13.3594H0ZM5.07812 18.4375H1.5625V14.9219H5.07812V18.4375Z",
    fill: "#1F1F1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 15.8984H2.53906V17.4609H4.10156V15.8984Z",
    fill: "#1F1F1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 7.69531H1.5625V9.25781H3.125V7.69531Z",
    fill: "#1F1F1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 10.8203V9.25781H3.125V10.8203H4.64844V12.3828H6.21094V10.8203H4.6875Z",
    fill: "#1F1F1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.00781H10.9375V4.57031H12.5V3.00781Z",
    fill: "#1F1F1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.5625H7.8125V4.57031H9.375V1.5625Z",
    fill: "#1F1F1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 0H9.375V1.5625H10.9375V0Z",
    fill: "#1F1F1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.57031V6.13281H7.8125V7.69531H10.9375V4.57031H9.375Z",
    fill: "#1F1F1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 13.8672V12.3438H9.375V9.25781H7.8125V12.3828H9.375V13.9062H10.9375V15.4297H14.0625V13.8672H10.9375Z",
    fill: "#1F1F1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.69531H10.9375V10.8203H12.5V7.69531Z",
    fill: "#1F1F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 9.21875V7.69531H15.5859V9.25781H14.0625V10.8203H15.625V12.3438H20V9.21875H18.4375ZM18.4375 10.7812H15.625V9.25781H18.4375V10.7812Z",
    fill: "#1F1F1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.8672H18.4375V16.9922H20V13.8672Z",
    fill: "#1F1F1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 10.8203H12.5V12.3828H14.0625V10.8203Z",
    fill: "#1F1F1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 15.4297H14.0625V16.9922H15.625V15.4297Z",
    fill: "#1F1F1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 13.8672H15.625V15.4297H17.1875V13.8672Z",
    fill: "#1F1F1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.9922V20H17.1875V18.5547H18.4375V16.9922H15.625Z",
    fill: "#1F1F1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.9062H7.8125V16.875H9.375V13.9062Z",
    fill: "#1F1F1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.4375V16.875H9.375V20H10.9375V18.4375H12.4609V20H14.0234V18.4375H12.5Z",
    fill: "#1F1F1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 7.69531H4.6875V9.25781H7.8125V7.69531Z",
    fill: "#1F1F1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 9.25781H0V12.3828H1.5625V9.25781Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr-icon.6662927d70200c687c8b1185bfd28a75.svg";
export { ForwardRef as ReactComponent };